import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactHero from "../components/ContactComponents/ContactHero";
import ContactSection from "../components/ContactSection";

const Contact = () => {
    const pageTitle = "Contact Vikash Tiwari | Hire Android & Web Developer";
    const pageDescription = "Get in touch with Vikash Tiwari for software development inquiries, Android/Flutter mobile app development, React/Next.js projects, or technical consulting.";
    const siteUrl = "https://vikashtiwaridev.web.app/contact";
    const ogImageUrl = "https://vikashtiwaridev.web.app/og-contact.jpg";

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Contact Vikash Tiwari",
        "description": pageDescription,
        "url": siteUrl,
        "mainEntity": {
            "@type": "Person",
            "name": "Vikash Tiwari",
            "jobTitle": "Software Developer",
            "url": "https://vikashtiwaridev.web.app/",
            "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "customer service",
                "availableLanguage": ["English", "Hindi"]
            }
        }
    };

    return (
        <>
            <Helmet>
                {/* Core Metadata */}
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="icon" type="image/x-icon" href="https://vikashtiwaridev.web.app/VikashTiwariIcon.png" />
                <meta name="keywords" content="Contact Vikash Tiwari, Hire Android Developer, Freelance Mobile Developer, Hire Flutter Engineer, Software Development Consultation,  Vikash Tiwari, Software Developer, Android Developer, Next.js Developer, React Portfolio, Firebase Solutions, Freelance Software Developer,
        Hire Software Developer,
Hire React Developer,
Hire React.js Developer,
Hire Next.js Developer,
Hire Flutter Developer,
Hire Android Developer,
Hire Web Developer,
Hire Full Stack Developer,
Remote Software Developer,
Freelance Developer India,
Freelance Developer Delhi,
Freelance Developer Noida,

Software Developer India,
Software Developer Delhi,
Software Developer Delhi NCR,
Software Developer Noida,

Software Consultant,
Software Consultant India,
Software Consultant Delhi,
Software Consultant Noida,

Software Development,
Custom Software Development,
Business Software Development,
Enterprise Software,
Software Development Company India,
Software Development Company Delhi,
Software Development Company Noida,
Software Development Company Ghaziabad,

Website Development Company,
Website Development Delhi,
Website Developer Noida,
Web Application Development,
Responsive Website Development,
SEO Friendly Website,
Performance Optimization,
PWA Development,

React.js Developer,
React Frontend Developer,
React Development Services,
React Website Development,
React Freelancer,
React Developer Noida,

Next.js Developer,
Next.js Development,
Next.js Website Development,
Next.js Expert,
Next.js Freelancer,

Flutter Developer,
Flutter App Development,
Flutter Freelancer,
Flutter App Developer India,
Flutter Consulting,
Cross Platform App Development,

Android Developer,
Android App Development,
Mobile App Development,
Mobile App Development Company,
Mobile App Developer India,
iOS App Development,

Node.js Developer,
Express.js,
MongoDB,
Firebase,
Supabase,
REST API,
JavaScript,
TypeScript,
React.js,
Next.js,
Node.js,
Tailwind CSS,
Shadcn UI,

Startup Software Developer,
Startup MVP Development,
Startup MVP Developer,
MVP Developer,
Build Startup MVP,
Prototype Development,
Product Development,
Startup App Development,
Startup Tech Partner,
Technical Co-Founder,
SaaS MVP,
SaaS Development,

AI Chatbot Developer,
Custom AI Chatbot,
AI Chatbot Development,
AI Automation,
Business Automation,
OpenAI Integration,
Gemini API Integration,
Build AI Chatbot for Business,

CRM Development,
ERP Development,
Cloud Application Development,

Hire Freelance React Developer,
Hire Next.js Freelancer,
Hire Flutter Developer India,
Hire Remote React Developer,
Hire Full Stack Developer India,
Best Freelance Software Developer,
React Website Development Company,
Flutter Mobile App Development Services,
Website Development for Startups,
Custom Software Development Company India,
Startup Software Development Company,

Vikash Tiwari,
Vikash Tiwari Portfolio,
Vikash Tiwari Developer,
Vikash Tiwari Software Developer,
Vikash Tiwari React Developer,
Vikash Tiwari Next.js Developer,
Vikash Tiwari Flutter Developer,
Vikash Tiwari Android Developer,
Vikash Tiwari AI Developer,
Vikash Tiwari Web Developer,
Vikash Tiwari Mobile App Developer,
Vikash Tiwari Software Consultant" />
                <meta name="author" content="Vikash Tiwari" />
                <link rel="canonical" href={siteUrl} />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content={siteUrl} />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={ogImageUrl} />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content={siteUrl} />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:image" content={ogImageUrl} />

                {/* Structured JSON-LD Schema */}
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>

            <main>
                <ContactHero />
                <ContactSection />
            </main>
        </>
    );
};

export default Contact;